import React from 'react';
import PropTypes from 'prop-types';
import HeadshotComponent from './headshot';
import StringUtils from '../utils/string';
import moment from 'moment';

class Conversation extends React.Component {
  componentDidMount() {
    if (!this.props.readState && this.props.active) {
      this.props.fetchActive(this.props.conversation);
    }
  }

  handleConversationClick() {
    if (!this.props.active) {
      this.props.selectLoad(this.props.conversation);
    }
  }

  conversationContent() {
    const notQuorum = this.props.users.length === 0;
    const message = this.props.conversation.headlineMessage;
    let textBody;
    let userId;
    let user;

    if (notQuorum) { return ''; }

    textBody = message.body.replace(/(<([^>]+)>)/g, '');

    if (message.isSystemMessage) {
      userId = message.creator.id;
      user = this.props.users.find(user => { return user.id === userId; });

      textBody = user ? `${user.displayName} ${textBody}` : '';
    }

    textBody = $('<div>').html(textBody).text();
    return StringUtils.truncateText(textBody, 60);
  }

  headshot() {
    let headshotObj;

    if (this.props.conversation.attachedToEvent) {
      const conversation = this.props.conversation;
      headshotObj = {
        id: conversation.id,
        headShotImage: conversation.eventImage,
        displayName: conversation.name
      };
    } else {
      headshotObj = this.props.users;
    }

    return <HeadshotComponent user={headshotObj} />;
  }

  conversationDetails() {
    const timestamp = this.props.conversation.headlineMessage.createdAt;

    return (
      <div className="conversation-info">
        <p className="t5 dark-gray" title={timestamp}>
          {StringUtils.formatTimestampForDrawerConversation(timestamp)}
        </p>
        {
          this.props.readState
            ? null
            : <p className="t5">
              <i className="fa fa-envelope text-blue1" aria-hidden="true"></i>
            </p>
        }
      </div>
    );
  }

  roomLabel() {
    const users = this.props.users;

    if (this.props.conversation.name) {
      return StringUtils.truncateText(this.props.conversation.name, 33);
    }

    let inner = users[0].displayName;
    if (users.length > 1) { inner += ` + ${users.length - 1}`; }

    return inner;
  }

  render() {
    const klassList = ['conversation'];
    if (this.props.active) { klassList.push('active'); }

    return (
      <div className={klassList.join(' ')} onClick={this.handleConversationClick.bind(this)}>
        <div className="clearfix">
          {this.headshot()}
          {this.conversationDetails()}

          <div className="conversation-content">
            <p className="t5 w3">
              {this.roomLabel()}
            </p>

            <p className="t5">
              {this.conversationContent()}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

Conversation.propTypes = {
  users: PropTypes.array.isRequired,
  active: PropTypes.bool.isRequired,
  readState: PropTypes.bool.isRequired,
  conversation: PropTypes.object.isRequired,
  fetchActive: PropTypes.func.isRequired,
  selectLoad: PropTypes.func.isRequired,
  archive: PropTypes.func.isRequired
};

export default Conversation;
